import { render, staticRenderFns } from "./internalTime.vue?vue&type=template&id=38718e42&scoped=true"
import script from "./internalTime.vue?vue&type=script&lang=js"
export * from "./internalTime.vue?vue&type=script&lang=js"
import style0 from "./internalTime.vue?vue&type=style&index=0&id=38718e42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38718e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38718e42')) {
      api.createRecord('38718e42', component.options)
    } else {
      api.reload('38718e42', component.options)
    }
    module.hot.accept("./internalTime.vue?vue&type=template&id=38718e42&scoped=true", function () {
      api.rerender('38718e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/customerTimelinessManagement/component/internalTime.vue"
export default component.exports